// This file must be imported first to set up jQuery globally
import $ from "jquery";

// Make jQuery available globally for Bootstrap and Summernote
window.jQuery = window.$ = $;

export default $;
